var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w-100"},[_c('span',{},[_vm._v(_vm._s(_vm.currency != null && _vm.currency != "" ? " "+_vm.currency : "")+_vm._s(_vm.text != null && _vm.text != "" ? _vm.text : ""))])])}
var staticRenderFns = []

export { render, staticRenderFns }